import { render, staticRenderFns } from "./DeviceLink.vue?vue&type=template&id=5b56d760&scoped=true"
import script from "./DeviceLink.vue?vue&type=script&lang=ts"
export * from "./DeviceLink.vue?vue&type=script&lang=ts"
import style0 from "./DeviceLink.vue?vue&type=style&index=0&id=5b56d760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b56d760",
  null
  
)

export default component.exports